import { render, staticRenderFns } from "./AvailableCoursesList.vue?vue&type=template&id=4afb1ad4&scoped=true&"
import script from "./AvailableCoursesList.vue?vue&type=script&lang=js&"
export * from "./AvailableCoursesList.vue?vue&type=script&lang=js&"
import style0 from "./AvailableCoursesList.vue?vue&type=style&index=0&id=4afb1ad4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afb1ad4",
  null
  
)

export default component.exports